import React from 'react';
import ImageUpload from '../ImageUpload';

const AboutAdmin = ({ siteData, updateSiteData, setSiteData, showSaveStatus }) => {
    const handleAboutUpdate = async (field, value) => {
        try {
            const updatedAbout = {
                ...siteData.about,
                [field]: value
            };

            setSiteData(prev => ({
                ...prev,
                about: updatedAbout
            }));

            await updateSiteData('about', updatedAbout);
            showSaveStatus('About section updated successfully!');
        } catch (error) {
            console.error('Failed to update about:', error);
            showSaveStatus('Failed to update about section', true);
        }
    };

    return (
        <div className="space-y-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">About Section</h2>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Section Title</label>
                <input
                    type="text"
                    value={siteData.about.title || ''}
                    onChange={(e) => handleAboutUpdate('title', e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sage-500 focus:border-transparent"
                    placeholder="About Me"
                />
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Content</label>
                <textarea
                    value={siteData.about.content || ''}
                    onChange={(e) => handleAboutUpdate('content', e.target.value)}
                    rows={8}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sage-500 focus:border-transparent"
                    placeholder="Tell your story here..."
                />
                <p className="text-xs text-gray-500 mt-1">Use line breaks to create paragraphs</p>
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">About Image</label>
                <ImageUpload
                    currentImage={siteData.about.image}
                    currentImagePath={siteData.about.imagePath}
                    onImageUpload={async (imageUrl, imagePath) => {
                        try {
                            const updatedAbout = {
                                ...siteData.about,
                                image: imageUrl,
                                imagePath: imagePath
                            };

                            setSiteData(prev => ({
                                ...prev,
                                about: updatedAbout
                            }));

                            await updateSiteData('about', updatedAbout);
                            showSaveStatus('About image updated successfully!');
                        } catch (error) {
                            console.error('Failed to update about image:', error);
                            showSaveStatus('Failed to update about image', true);
                        }
                    }}
                    label="Upload About Image"
                    folder="about"
                    aspectRatio={4 / 3}
                />
            </div>
        </div>
    );
};

export default AboutAdmin;